import React from 'react';
// import classNames from 'classnames';

export default function LockIcon({ className = '' }) {
	// TODO: Waiting for Icon name from FS fonts
	// return <span className={classNames('icon icon-union', className)} />;
	return (
		<svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.5 3.97345C2.5 2.59274 3.61929 1.47345 5 1.47345C6.38071 1.47345 7.5 2.59274 7.5 3.97345V4.86017H2.5V3.97345ZM1.5 4.86017V3.97345C1.5 2.04045 3.067 0.47345 5 0.47345C6.933 0.47345 8.5 2.04045 8.5 3.97345V4.86017H9H10V5.86017V10.5268V11.5268H9H1H0V10.5268V5.86017V4.86017H1H1.5ZM1 10.5268V5.86017H9V10.5268H1Z"
				fill="white"
			/>
		</svg>
	);
}
